module.exports = __webpack_public_path__ + "img/computer_img.ee235016.png";